module.exports = __webpack_public_path__ + "static/img/lunbo1.cdf29b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/desktop/lunbo1.jpg
// module id = HkRI
// module chunks = 15